import { Alert, Container, Stack, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useMutation } from 'urql'
import { graphql } from '../../gql'

type AcceptInvitationProps = {
  invitationId: string
  onCompleted?: () => void
}
export const AcceptInvitation = (props: AcceptInvitationProps) => {
  const { invitationId, onCompleted } = props
  const [acceptInvitationResult, acceptInvitation] = useMutation(
    graphql(`
      mutation AcceptInvitation($invitationId: String!) {
        AcceptInvitation(invitationId: $invitationId)
      }
    `),
  )
  useEffect(() => {
    if (acceptInvitationResult.fetching || acceptInvitationResult.error) return
    ;(async () => {
      await acceptInvitation({ invitationId }, { requestPolicy: 'network-only' })
    })()
  }, [invitationId, acceptInvitation, acceptInvitationResult])

  useEffect(() => {
    if (acceptInvitationResult.data) {
      onCompleted?.()
    }
  }, [acceptInvitationResult, onCompleted])

  if (acceptInvitationResult.error) {
    setTimeout(() => {
      window.location.href = '/'
    }, 3000)
    return (
      <Container maxWidth="sm">
        <Stack spacing={2} alignItems="center" mt={4}>
          <Alert severity="error">{acceptInvitationResult.error.message.replace(/^\[GraphQL\]/, '')}</Alert>
          <Typography>This invitation may have expired or has already been accepted.</Typography>
          <Typography>You will be redirected in a moment</Typography>
        </Stack>
      </Container>
    )
  }
  return (
    <Container maxWidth="sm">
      <Stack spacing={2} alignItems="center" mt={4}>
        <Typography variant="h1">Accepting Invitation...</Typography>
      </Stack>
    </Container>
  )
}
